import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const RoleResource = () => {
  return Vue.resource('roles{/id}')
}



// WEBPACK FOOTER //
// ./src/api/role.js